import { useEffect, useRef, useState } from "react";
import { motion, useInView, animate } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const Eyebrow = ({ index, children, light = false }) => (
  <div className="flex items-center gap-3" data-testid={`eyebrow-${index}`}>
    <span className="font-display text-xs font-bold tracking-widest text-gold">
      {index}
    </span>
    <span className="h-px w-8 bg-gold/50" />
    <span
      className={`text-[11px] font-semibold uppercase tracking-[0.32em] ${
        light ? "text-graphite/60" : "text-ivory/50"
      }`}
    >
      {children}
    </span>
  </div>
);

export const CountUp = ({ to, className = "" }) => {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: "-40px" });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const controls = animate(0, to, {
      duration: 2,
      ease: [0.22, 1, 0.36, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, to]);

  return (
    <span ref={ref} className={className}>
      {val.toLocaleString("en-IN")}
    </span>
  );
};
